import { useMemo } from "react"
import { TcpReportData } from "../typesExtendedReport"
import { useMappedExtendedData } from "../useMappedExtendedData"
import { safeNum } from "../utils/extendedUtils"


export const useTcpMappedData = (data: TcpReportData | null | undefined, palette: string[]) => {
    const base = useMappedExtendedData(data, palette)

    return useMemo(() => {
        if (!data || !base) return null

        return {
            ...base,
            fields: {
                projectTotalCount: safeNum(data.projectTotalCount),
                operationTotalCount: safeNum(data.operationTotalCount),
                averageAge: safeNum(data.averageAge),
                idbApprovedAmountOriginal: safeNum(data.idbApprovedAmount_Original),
                idbApprovedAmountCurrent: safeNum(data.idbApprovedAmount_Current),
                disbursementPercent: safeNum(data.disbursementPercent),
                disbursementAmount: safeNum(data.disbursementAmount),
                withoutDisbursingAmount: safeNum(data.withoutDisbursingAmount),
                pendingLegalValidity: safeNum(data.pendingLegalValidity),
                projectsOverdueDisbursement: safeNum(data.projectsOverdueDisbursement),
                projectTotalCountNational: safeNum(data.projectTotalCountNational),
                projectTotalCountRegional: safeNum(data.projectTotalCountRegional),
                customerSupportPercent: safeNum(data.taxonomy.customerSupportPercent),
                loanPortfolioSupportPercent: safeNum(data.taxonomy.loanPortfolioSupportPercent),
                researchDisseminationPercent: safeNum(data.taxonomy.researchDisseminationPercent),
                urdOffice: safeNum(data.participation.urdOffice),
                participant8Countries: safeNum(data.participation.participant8Countries),
                participantPlus8Countries: safeNum(data.participation.participantPlus8Countries),
                executedByBankPercent: safeNum(data.execution.executedByBankPercent),
                executedByExecutingAgencyPercent: safeNum(data.execution.executedByExecutingAgencyPercent),
            },
        };
    }, [data, base]);
};
